import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function profileReducer(state = initialState.profile, action) {
  switch (action.type) {
    case types.LOAD_ENGINEER_SUCCESS:
    case types.REFRESH_ENGINEER:
      return action.profile;

    default:
      return state;
  }
}
